import React, { Component } from "react";
import { Helmet } from "react-helmet";
import "./style.css";
import Form from "react-bootstrap/Form";
import Button from "components/Button/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import logo from "Assets/loginLogo.svg";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import axios from "axios";
import {environment,HeaderConfig,myHeaders_Autorized,user_API } from "Api/Api";
const locationSearchAPI = environment.location_Search;

class EmailVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      loading: true,
      validated: false,
      ModalLoader: false,
      city_Data: [],
      city:null,
      hidden: true,
      hiddenNew:true,
      emailCheck:'',
      clicked: true,
      clickedNew:true,
      InvalidResendMsg: 0,
    };
  }
  componentDidMount() {
    document.body.style.background = "#343E47";
    let tempArr = [];
    axios
      .get(
        `${locationSearchAPI}?coordinates_lat=0&coordinates_lon=0&radius=1000`,
        HeaderConfig
      )
      .then(response => {
        let minified_res = response.data.search_query_results;
        minified_res.forEach(function(element) {
          tempArr.push(element.entity_info);
        });
        this.setState({ city_Data: tempArr, loading: false });
        if (this.state.city_Data !== null) {
          let city_Data = this.state.city_Data[0].city_name;
          this.setState({ city: city_Data });
        }
      })
      .catch(error => {
      });

  }
// email validation
  myEmailChangeHandler = event => {
    if (event.target.id === "userEmailAddress") {
      this.setState({ emailCheck: event.target.value });
    }
  }
  emailSubmitData = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else if (form.checkValidity() !== false) {
        event.preventDefault();
        const {emailCheck} = this.state;
        this.setState({ ModalLoader: true,InvalidResendMsg: 0 });
        let callback_base_url = window.location.protocol+'//'+window.location.hostname+'/';
        let EmailData = {
          "email": emailCheck,
          "callback_url": callback_base_url+'resetpassword'
        }
      axios.post(`${user_API}/sendResetPasswordEmail`, JSON.stringify(EmailData),myHeaders_Autorized)
      .then((response) => {
        this.setState({ ModalLoader: false, InvalidResendMsg: 1,})
      })
        .catch((error) => {
            this.setState({ ModalLoader: false, InvalidResendMsg: 2,})
        });
    }
    this.setState({ validated: true });
  };

// Showing Valid and Invalid messages
messageResend = () => {
  const {InvalidResendMsg  } =this.state;
  return(
      <div style={{ display: this.state.InvalidResendMsg === 0 ? "none" : null }} className="Invalid-section resend-msg">
      {
          (InvalidResendMsg === 1) ?
          <span className="Valid-Msg">Reset password link has been sent to the email address provided - please check your email</span>
          :
          (InvalidResendMsg === 2) ?
          <span className="Valid-Msg">Reset password link has been sent to the email address provided - please check your email</span>
          //<span className="Invalid-Msg">Reset password email not sent - please try again</span>
          :
          null
      }
  </div>
  )
}

  emailVerification=()=>{
    return (
    <div className="Login-body">
      <h4>Forgot Password?</h4>
      <p className="email-body">Enter the email address you used when you joined and we'll send you instructions to update your password.</p>
      <div className="Form-section">
        <Form
          noValidate
          validated={this.state.validated}
          onSubmit={this.emailSubmitData}
        >
          <div style={{ display: this.state.InvalidResendMsg === 1 ? "none" : null }}>
          <Form.Row>
            <Form.Group as={Col} md="12" controlId="userEmailAddress">
              <Form.Label>EMAIL ADDRESS</Form.Label>
              <Form.Control
                required
                type="email"
                value={this.state.emailCheck}
                onChange={this.myEmailChangeHandler}
                placeholder="Enter your Email Address"
              />
            </Form.Group>
          </Form.Row>
          </div>
          {this.state.ModalLoader === false ? (
            <div>
               {this.messageResend()}
               <div style={{ display: this.state.InvalidResendMsg === 1 ? "none" : null }}>
                  <Button theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5">
                    Send Update Instructions
                  </Button>
                </div>
            </div>
          ) : (
            <ActivityIndicator theme="button-Status-Loader" />
          )}

        </Form>
      </div>
    </div>
    )
  };

  render() {
    if (this.state.loading) {
      return <ActivityIndicator theme="spinner" />;
    } else {
      return (
        <>
        <Helmet>
          <title>PechaKucha Send Reset Password Email</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div className="Login-grid pad-top100">
          <Row className="nomargin">
            <Col lg={12}>
              <div className="flex-center logo-container">
              <a href="/"><img
                  src={logo}
                  alt="img"
                  className="img-fluid navbar-brand img-logo"
                /></a>
              </div>
              <div className="Login-Form">
                {this.emailVerification()}
              </div>
            </Col>
            <Col lg={12}>
              <div className="flex-center Forget-password">
                  <p>Already have an account? <a href="/login">Login</a></p>
              </div>
            </Col>
          </Row>
        </div>
        </>
      );
    }
  }
}

export default EmailVerification;
